import { useEffect } from "react";

export const useLockScroll = () => {
  useEffect(() => {
    document.body.classList.add("body-scroll-lock");

    return () => {
      document.body.classList.remove("body-scroll-lock");
    };
  }, []);
};
